import React from 'react'

class AnswersInfo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      idToadd: 0,
      answersInfo: [
        {
          id: 0,
          answer: '',
          correct: 'false',
          placeholder: '',
        },
      ],
      disablePlusButton: false,
      listOptionsSwitch: false,
      questionInfoObjInAns: {},
    }
  }
  componentDidMount() {
    this.plusButtonVisible()
    if (this.props.mcqDetails && this.props.mcqDetails.answersInfo) {
      const answers = this.props.mcqDetails.answersInfo
      answers.sort((a, b) => parseFloat(a.ordering) - parseFloat(b.ordering))
      answers.map((item) => {
        delete item.__typename
      })
      this.setState({
        answersInfo: this.props.mcqDetails.answersInfo,
        listOptionsSwitch: this.props.mcqDetails.listOptionsSwitch,
      })
      this.props.updateAnswersInfo(this.props.mcqDetails.answersInfo)
    }
  }
  componentDidUpdate = (prevProps) => {
    if (prevProps.contentSelectedLangVal != this.props.contentSelectedLangVal) {
      this.plusButtonVisible()
      if (this.props.mcqDetails && this.props.mcqDetails.answersInfo) {
        const answers = this.props.mcqDetails.answersInfo
        answers.sort((a, b) => parseFloat(a.ordering) - parseFloat(b.ordering))
        answers.map((item) => {
          delete item.__typename
        })
        this.setState({
          answersInfo: this.props.mcqDetails.answersInfo,
          listOptionsSwitch: this.props.mcqDetails.listOptionsSwitch,
        })
        this.props.updateAnswersInfo(this.props.mcqDetails.answersInfo)
      }
    }
  }

  updateAnswersInfoInMcq = () => {
    this.props.updateAnswersInfo(this.state.answersInfo)
  }

  toggleIsCorrect = (index) => {
    const answerInfo = this.state.answersInfo
    answerInfo[index].correct = answerInfo[index].correct == 'true' ? 'false' : 'true'
    this.setState({ answersInfo: answerInfo }, () => {
      this.updateAnswersInfoInMcq()
    })
  }
  handleAnswer = (e, index) => {
    const answerInfo = this.state.answersInfo
    answerInfo[index][`answer_${this.props.contentSelectedLangVal}`] = e.target.value
    this.setState({ answersInfo: answerInfo }, () => {
      this.plusButtonVisible()
      this.updateAnswersInfoInMcq()
    })
  }
  addAnswer = () => {
    const answerInfo = this.state.answersInfo
    answerInfo.push({
      id: this.state.idToadd + 1,
      answer: '',
      correct: 'false',
      placeholder: '',
    })
    this.setState({ answersInfo: answerInfo, disablePlusButton: true })
  }
  plusButtonVisible = async () => {
    await this.state.answersInfo.find((item) => {
      if (item.answer == '') {
        this.setState({ disablePlusButton: true })
        return true
      } else {
        this.setState({ disablePlusButton: false })
      }
    })
  }
  handleRemoveAnswer = (index) => {
    const answerInfo = this.state.answersInfo
    answerInfo.splice(index, 1)
    answerInfo.map((item, index) => {
      item.id = index
    })
    this.setState(
      {
        answersInfo: answerInfo,
        idToadd: this.state.idToadd - 1,
        disablePlusButton: answerInfo.length > 0 ? true : false,
      },
      () => {
        this.plusButtonVisible()
        this.props.updateAnswersInfo(this.state.answersInfo)
      }
    )
  }

  renderItem = (item, index) => {
    const answervalue = item.answer
    return (
      <div>
        <div>
          <div>
            <input
              value={item.correct}
              type='radio'
              checked={item.correct == 'true'}
              onChange={() => {
                this.toggleIsCorrect(index)
              }}
            ></input>
            <input
              type='text'
              onChange={(e) => {
                this.handleAnswer(e, index)
              }}
              value={item[`answer_${this.props.contentSelectedLangVal}`]}
              placeholder='Please Enter Answer '
            ></input>
            <text onClick={() => this.handleRemoveAnswer(index)}>X</text>
          </div>
        </div>
      </div>
    )
  }
  updateOrdering = (data) => {
    data = data.filter((item, index) => {
      item.ordering = index + 1
      return item
    })
    this.setState({ answersInfo: data })
  }

  render() {
    const { answersInfo } = this.state
    return (
      <div className='flex-container'>
        <div>
          <text for='text'>Answer Options :</text>

          {answersInfo.map((word, idx) => {
            return (
              <div key={idx} className='flex-item'>
                {this.renderItem(word, idx)}
              </div>
            )
          })}
        </div>
        <button onClick={() => this.addAnswer()}>{'Add Option'}</button>
      </div>
    )
  }
}

export default AnswersInfo
